import {
  AfterViewChecked,
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
  NgZone,
  OnDestroy,
  Renderer2,
} from '@angular/core';
import { fromEvent, Subject, Subscription } from 'rxjs';

@Directive({
  selector: '[txtbProportionalImage]',
  standalone: false,
})
export class ProportionalImageDirective implements AfterViewInit, OnDestroy, AfterViewChecked {
  @Input() proportionalWidth = 1600;
  @Input() proportionalHeight = 900;
  @Input() isScrolled: boolean | undefined = false;

  subscription = new Subscription();
  #updateBounds$ubject = new Subject<void>();

  constructor(
    private hostRef: ElementRef<HTMLImageElement>,
    private ngZone: NgZone,
    private renderer: Renderer2
  ) {}

  _maxWidth: number | undefined | null;

  @Input() set maxWidth(v: number | undefined | null) {
    this._maxWidth = v;
    this.#updateBounds$ubject.next();
  }

  _maxHeight: number | undefined | null;

  @Input() set maxHeight(v: number | undefined | null) {
    this._maxHeight = v;
    this.#updateBounds$ubject.next();
  }

  @HostListener('load') onLoad(): void {
    this.#updateBounds$ubject.next();
  }

  calculateAspectRatioFit(
    srcWidth: number,
    srcHeight: number,
    maxWidth: number,
    maxHeight: number
  ): { width: number; height: number } {
    const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    return { width: srcWidth * ratio, height: srcHeight * ratio };
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public ngAfterViewInit(): void {
    if (this.isScrolled) {
      return;
    }
    this.ngZone.runOutsideAngular(() => {
      this.subscription.add(
        fromEvent(window, 'resize').subscribe(() => {
          this.aspectRadio();
        })
      );
    });
  }

  public ngAfterViewChecked(): void {
    this.aspectRadio();
  }

  private aspectRadio(): void {
    const { naturalWidth, naturalHeight } = this.hostRef.nativeElement;
    const parentBounds = (
      this.hostRef.nativeElement?.parentNode as HTMLElement
    )?.getBoundingClientRect();

    let scaleX = naturalWidth / this.proportionalWidth;
    let scaleY = naturalHeight / this.proportionalHeight;

    if (!this.isScrolled) {
      scaleX = 1;
      scaleY = 1;
    }

    const { width, height } = this.calculateAspectRatioFit(
      naturalWidth,
      naturalHeight,
      parentBounds.width * scaleX,
      parentBounds.height * scaleY
    );
  }
}
